<!-- <div class="spinner"> -->
  <!-- <div class="spinner-backdrop">  
    <div class="spinner-obj"> 
      <div class="sk-circle">
        <div class="sk-circle1 sk-child"></div>
        <div class="sk-circle2 sk-child"></div>
        <div class="sk-circle3 sk-child"></div>
        <div class="sk-circle4 sk-child"></div>
        <div class="sk-circle5 sk-child"></div>
        <div class="sk-circle6 sk-child"></div>
        <div class="sk-circle7 sk-child"></div>
        <div class="sk-circle8 sk-child"></div>
        <div class="sk-circle9 sk-child"></div>
        <div class="sk-circle10 sk-child"></div>
        <div class="sk-circle11 sk-child"></div>
        <div class="sk-circle12 sk-child"></div>
      </div>
    </div>
  </div>      -->
<!-- </div> -->
<!-- <div class="ups-truck-spinner-container">
  <div class="ups-truck-spinner">
    <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" />
  </div>
</div> -->
<!-- <div class="ups-truck-spinner-container">
  <div class="ups-truck-spinner">
    <div class="truck-animation-container">
      <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" class="ups-truck-image" />
    </div>
    <div class="loading-text">Loading...</div>
  </div>
</div> -->
<!-- <div class="ups-truck-spinner-container content-only">
  <div class="ups-truck-spinner">
    <div class="truck-animation-container">
      <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" class="ups-truck-image" />
    </div>
    <div class="loading-text">Loading...</div>
  </div>
</div> -->
<!-- <div class="ups-truck-spinner-container">
  <div class="ups-truck-spinner">
    <div class="truck-animation-container">
      <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" class="ups-truck-image" />
    </div>
     <div class="loading-text">Loading...</div>
  </div>
</div> -->

<!-- <div class="ups-truck-spinner-container">
  <div class="ups-truck-spinner">
    <div class="truck-animation-container">
      <div class="ups-road-stripe"></div>
      <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" class="ups-truck-image" />
    </div>
     <div class="loading-text">Loading<span class="loading-dots">...</span></div>
  </div>
</div> -->
<div class="ups-truck-spinner-container">
  <div class="ups-truck-spinner">
    <div class="truck-animation-container">
      <div class="ups-road-stripe"></div>
      <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" class="ups-truck-image" />
      <div class="loading-text">Loading<span class="loading-dots">...</span></div>
    </div>
  </div>
</div>